import "./App.css";
import WeatherApp from "./WeatherApp";

function App() {
  return (
    <div className="App">
      <div className="container">
        <WeatherApp city="New York" />
      </div>
      <footer className="text-center">
        This website was coded by Irene Bellani and is available on{" "}
        <a href="https://github.com/Ireb91/weather-react" target="_blank">
          Github
        </a>{" "}
      </footer>
    </div>
  );
}

export default App;
